export type WH = {
  width: number,
  height: number
}

/**
 * pxとmmの変換などを行うメソッド群
 * dpiの初期値はオンラインラボの仕様に合わせて暫定で設定
 */
class PixelConverter {

  // 1インチをmmに変換した値
  public static readonly INCH = 25.4;
  // オンラインラボで使われているlayout.xmlのdpi
  public static readonly LABO_DPI = 300;
  public static readonly CSS_DPI = 96;

  /**
   * mmをpxに変換
   * @param {number} mm 変換したいmmの値
   * @param {number} dpi 基準となる解像度(初期値sift-web)
   * @returns {number} mmをpxに変換した値
   */
  static mmToPx(mm: number | string, dpi: number = this.LABO_DPI): number {
    return Math.round((Number(mm) / this.INCH) * dpi);
  }

  /**
   * mmの高さと幅オブジェクトをpxに変換
   * @param {WH} wh 変換したいmmの幅と高さオブジェクト
   * @param {number} dpi 基準となる解像度(初期値sift-web)
   * @returns {WH} mmをpx変換した幅と高さオブジェクト
   */
  static mmWHToPxWH(wh: WH, dpi: number = this.LABO_DPI): WH {
    return {
      width: Math.round((wh.width / this.INCH) * dpi),
      height: Math.round((wh.height / this.INCH) * dpi)
    }
  }

  /**
   * pxをmmに変換
   * @param {number} px 変換したいpxの値
   * @param {number} dpi 基準となる解像度(初期値sift-web)
   * @returns {number} pxをmmに変換した値
   */
  static pxToMm(px: number, dpi: number = this.LABO_DPI): number {
    return Math.round((px / dpi) * this.INCH * 10) / 10;
  }

  /**
   *　pxの高さと幅オブジェクトをmmに変換
   * @param {WH} wh 変換したいpxの幅と高さオブジェクト
   * @param {number} dpi 基準となる解像度(初期値sift-web)
   * @returns {WH} pxをmm変換した幅と高さオブジェクト
   */
  static pxWHToMmWH(wh: WH, dpi: number = this.LABO_DPI): WH {
    return {
      width: Math.round((wh.width / dpi) * this.INCH * 10) / 10,
      height: Math.round((wh.height / dpi) * this.INCH * 10) / 10,
    }
  }

  /**
   * pt定義されている値をdpiを考慮してpxに変換
   * @param {number} pt 変換したいpt
   * @param {number} dpi 基準となる解像度(初期値sift-web)
   * @returns {number} ptをpxに変換した値
   */
  static ptToPx(pt: number, dpi: number = 300): number {
    return (pt * dpi) / 72;
  }

  /**
   * px定義されている値をdpiを考慮してptに変換
   * @param {number} px 変換したいpx
   * @param {number} dpi 基準となる解像度(初期値sift-web)
   * @returns {number} pxをptに変換した値
   */
  static pxToPt(px: number, dpi: number = 300): number {
    return (px * 72) / dpi;
  }
}

export default PixelConverter
